import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Http } from '@angular/http';
import { RequestBuilder } from '../classes/request-builder';
import { Observable } from 'rxjs';
import * as Enum from '../utils/enums';

@Injectable()
export class UtenteService extends BaseService {

  /**
   * Costruttore
   * @param http Servizio di richieste HTTP 
   */
  constructor(http: Http) {
    super(http);
  }

  /**
   * Get list of Utenti without esecutori e aggiudicatari
   * @param reqBuilder 
   */
  getUtenti(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('utente/fetch', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * get all utenti
   * @param reqBuilder 
   * @returns 
   */
  getAllUtenti(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('utente/FetchAllUsers', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * Save/update Utente
   * @param reqBuilder 
   */
  save(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('utente/save', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * delete Utente
   * @param reqBuilder 
   */
  deleteUtente(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('utente/delete', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }


  /**
   * get list of Referenti
   * @param reqBuilder 
   * @returns 
   */
  getAllReferenti(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('utente/fetchReferenti', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }
}
